import axios from "axios";

export const getTerm = async (id) => {
  try {
    const { data } = await axios.get(`/api/v1/term?termId=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getTermsBySession = async (sessionId) => {
  try {
    const { data } = await axios.get(
      `/api/v1/term/session?sessionId=${sessionId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const addTerm = async ({
  name,
  sessionId,
  startDate,
  endDate,
  createdBy,
}) => {
  try {
    const { data } = await axios.post("/api/v1/term", {
      name,
      sessionId,
      startDate,
      endDate,
      createdBy,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const editTerm = async ({
  id,
  name,
  sessionId,
  startDate,
  endDate,
  modifiedBy,
}) => {
  try {
    const { data } = await axios.patch("/api/v1/term", {
      id,
      name,
      sessionId,
      startDate,
      endDate,
      modifiedBy,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteTerm = async (id) => {
  try {
    const { data } = await axios.delete(`/api/v1/term?termId=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteTermes = async (classes) => {
  try {
    const { data } = await axios.post("/api/v1/term/school", classes);
    return data;
  } catch (error) {
    throw error;
  }
};
